<template>

  <div class="attraction_slider splide">

    <div class="card-title">
      <h3>{{ $t('attractions-nearby') }}</h3>

      <div class="splide__arrows splide__arrows--ltr">
        <button
            class="splide__arrow splide__arrow--prev"
            type="button"
            aria-label="Previous slide"
            aria-controls="splide01-track">
          <TyIcon icon="ty-arrow-left" width="1rem"/>
        </button>
        <button
            class="splide__arrow splide__arrow--next"
            type="button"
            aria-label="Next slide"
            aria-controls="splide01-track">
          <TyIcon icon="ty-arrow-right" width="1rem"/>
        </button>
      </div>

    </div>

    <div class="splide__track">
      <div class="splide__list">
        <div v-for="attraction in accommodation.attractions" :key="attraction.id" class="splide__slide">
          <a class="card card-attraction"
             :href="attraction.page_urls[activeLocale.code] ? `/${attraction.page_urls[activeLocale.code]}` : null"
             target="_blank" :title="attractionTitle(attraction)">
            <div class="card-body">
              <div class="cb-content">

                <h3 class="h3-sm" v-if="attractionTitle(attraction).length > 100">
                  {{ attractionTitle(attraction).substring(0, 20) + '...' }}</h3>
                <h3 class="h3-sm" v-else>{{ attractionTitle(attraction) }}</h3>

                <p class="text-muted small mb-0" v-if="attraction.distance > 0 && attraction.distance.toFixed(0) > 0">
                  {{ attraction.distance.toFixed(0) }} km
                </p>
                <p class="text-muted small mb-0" v-else-if="attraction.distance > 0">
                  {{ (attraction.distance * 1000).toFixed(0) }} m
                </p>
                <p class="mb-0 d-none">
                  <TyIcon icon="ty-arrow-right" class="icon-color-dark" width=".7rem" height=".7rem"/>
                </p>
              </div>
              <p class="text-muted small text-decoration-underline mb-0"
                 v-if="attraction.page_urls[activeLocale.code]">{{ $t('show-more') }}
                <TyIcon icon="ty-arrow-right" width=".6rem"/>
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import supportsWebP from "supports-webp";
import {useNuxtApp} from "#app";
import {obtainActiveLocale} from "../../../../../composables/master_page";
import {onMounted, PropType} from "vue";
import Accommodation from "../../../../../lib/models/Accommodation";
import PlaceAttraction from "../../../../../lib/models/PlaceAttraction";
import {left} from "@popperjs/core";

const props = defineProps({
  accommodation: Object as PropType<Accommodation>
})
const {$isDesktop, $splide} = useNuxtApp();
const activeLocale = obtainActiveLocale();


onMounted(async () => {
  const Splide = await $splide();
  const splide = new Splide('.attraction_slider', {
    centered: false,
    type: 'slide',
    arrows: true,
    draggable: true,
    grabCursor: true,
    gap: '1rem',
    pagination: false,
    padding: {left: '.15rem', right: '.15rem'},


    breakpoints: {
      '250': {
        perPage: 1,
      },
      '425': {
        perPage: 1,
        padding: {left: '0rem', right: '4rem'},
      },
      '768': {
        perPage: 2,
      },
      '1024': {
        perPage: 3,
      },
      '9999': {
        perPage: 3,
      },
    }
  }).mount();
});


const hrefTarget = () => {
  return $isDesktop() ? "_blank" : "_self"
};

const showWebp = async () => {
  return await supportsWebP;
};

const attractionTitle = (attraction: PlaceAttraction) => {
  return attraction.langtitle[activeLocale.code] !== undefined && attraction.langtitle[activeLocale.code].length > 0 ? attraction.langtitle[activeLocale.code] : attraction.title
}
</script>
